import type { ShareBetData } from '@core/Areas/ShareBet/types'
import { getPlanSequenceFromSelection } from '@mobi/betslip/helpers/getPlanSequence'
import { isLoadBetSupported } from '@core/Areas/ShareBet/LoadBet/isLoadBetSupported'
import {
  isBetLoopShareData,
  isBetSlipShareData,
  isQuickbetShareData,
  isTicketShareData,
} from './typeGuards'

export function isSharedPlacedBetPending(data: ShareBetData) {
  if (isTicketShareData(data)) {
    return data.share.activeTab === 'pending'
  }

  if (isBetSlipShareData(data)) {
    return data.share.isBetPlaced
  }

  return true
}

export function isLoadBetSupportedWithShare(data: ShareBetData) {
  if (isBetLoopShareData(data)) {
    return false
  }

  if (isTicketShareData(data)) {
    return isLoadBetSupported(data.share.ticket.planSeq)
  }

  if (isBetSlipShareData(data) || isQuickbetShareData(data)) {
    const items = data.share.items
    return items.length > 1 || isLoadBetSupported(getPlanSequenceFromSelection(items[0].selection))
  }

  return false
}
